<template>
  <label>
    {{ label }}
    <select v-model="editableSelectedId" @change.stop.prevent="change">
      <option :value="0">-</option>
      <option v-for="(queryOption, index) in queries" :key="index" :value="queryOption.id">
        {{ queryOption.label }}
      </option>
      <option value="create-new">Create new query</option>
    </select>

    <div v-if="editableSelectedId === 'create-new'">
      <input v-model="createLabel" type="text" placeholder="New query label" />
      <span v-if="error" class="error">Label must be unique</span>
      <action-button :text="'Create query'" :state="state" @pressed="submit" @revertState="revertState"></action-button>
    </div>

    <router-link
      v-if="editableSelectedId && editableSelectedId !== 'create-new'"
      :to="{ path: '/queries/' + editableSelectedId }"
      >Go to query</router-link
    >
  </label>
</template>

<script>
import { mapState } from "vuex";

import actionButton from "@/components/actionButton";

export default {
  name: "QuerySelector",

  components: { actionButton },

  props: {
    queryId: {
      type: Number,
      required: false,
      default: 0
    },
    selectedQueryId: {
      type: [Number, String],
      default: 0
    },
    label: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      editableSelectedId: 0,
      createLabel: "",
      state: "normal",
      error: false
    };
  },

  computed: {
    ...mapState({
      queries: (state) => {
        return state.queries.all.filter((queryOption) => {
          return queryOption && queryOption.id !== state.queryId;
        });
      }
    })
  },

  watch: {
    selectedQueryId(newValue, oldValue) {
      // Only update if parent prop actually changed
      // Don't reset while user is actively selecting
      if (oldValue === undefined || oldValue !== newValue) {
        this.editableSelectedId = newValue;
      }
    }
  },

  mounted() {
    this.editableSelectedId = this.selectedQueryId;
  },

  methods: {
    submit() {
      this.state = "loading";

      const params = {
        label: this.createLabel,
        matcher_type: "and"
      };

      this.$store
        .dispatch("createQuery", params)
        .then((resp) => {
          this.state = "done";
          this.editableSelectedId = resp.data.data.attributes.id;
          this.error = false;
          this.change();
        })
        .catch(() => {
          this.state = "normal";
          this.error = true;
        });
    },

    revertState() {
      this.state = "normal";
    },

    change() {
      let selectedId = this.editableSelectedId;

      // Convert string to integer, handle special cases
      if (selectedId === "create-new") {
        selectedId = null;
      } else if (selectedId === "0" || selectedId === 0) {
        selectedId = null;
      } else {
        selectedId = parseInt(selectedId, 10);
      }

      this.$emit("change", selectedId);
    }
  }
};
</script>
